import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import config from '../config';
import './Navbar.css';

function Navbar() {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [topBarVisible, setTopBarVisible] = useState(config.topBar?.enabled ?? false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsOpen(false);
  }, [location]);

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/menu', label: 'Menu' },
    { path: '/services', label: 'Services' },
    { path: '/about', label: 'About' },
    { path: '/contact', label: 'Contact' },
  ];

  return (
    <>
      {topBarVisible && (
        <div className={`topbar ${scrolled ? 'topbar--hidden' : ''}`}>
          <div className="container topbar__container">
            <p className="topbar__message">{config.topBar.message}</p>
            <button className="topbar__close" onClick={() => setTopBarVisible(false)} aria-label="Close announcement">&times;</button>
          </div>
        </div>
      )}
      <nav className={`navbar ${scrolled ? 'navbar--scrolled' : ''} ${topBarVisible && !scrolled ? 'navbar--with-topbar' : ''}`}>
        <div className="navbar__container container">
        <Link to="/" className="navbar__logo">
          <img src="/images/logo.jpg" alt="FAL SUTRA Logo" className="navbar__logo-img" />
          <div className="navbar__logo-text">
            <span className="navbar__brand">{config.brand.name}</span>
            <span className="navbar__tagline">{config.brand.tagline}</span>
          </div>
        </Link>

        <div className={`navbar__links ${isOpen ? 'navbar__links--open' : ''}`}>
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`navbar__link ${location.pathname === link.path ? 'navbar__link--active' : ''}`}
            >
              {link.label}
            </Link>
          ))}
          <a
            href={config.getWhatsAppUrl('Hi! I want to order from FAL SUTRA 🍎')}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary navbar__cta"
          >
            Order Now
          </a>
        </div>

        <button
          className={`navbar__hamburger ${isOpen ? 'navbar__hamburger--open' : ''}`}
          onClick={() => setIsOpen(!isOpen)}
          aria-label="Toggle menu"
        >
          <span></span>
          <span></span>
          <span></span>
        </button>
      </div>

      {isOpen && <div className="navbar__overlay" onClick={() => setIsOpen(false)} />}
    </nav>
    </>
  );
}

export default Navbar;
